<template>
    <div>
        <div v-if="option.has_liaisons()">
            <div>Disponible pour les participants:</div>
            <div class="d-flex flex-wrap justify-start align-center sm-gap mb-1">
                <v-chip v-for="liaison_course in option.list_liaisons_course" :key="liaison_course.id" color="white"
                    variant="elevated" elevation="0" class=" spo-border">
                    <v-icon icon="mdi-check" color="primary" class="mr-1"></v-icon> {{ liaison_course.nom_course }}
                </v-chip>
                <v-chip v-for="liaison_pack in option.list_liaisons_pack" :key="liaison_pack.id" color="white"
                    variant="elevated" elevation="0" class=" spo-border">
                    <v-icon icon="mdi-check" color="primary" class="mr-1"></v-icon> Pack {{ liaison_pack.nom_pack }}
                </v-chip>

            </div>
        </div>
        <div v-else>
            <div>Ouvert à tous</div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["option"],

}
</script>

<style lang="scss" scoped></style>